import { Delete, Edit, Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

interface Props {
  onUpdate: () => void;
  onDelete: () => void;

  onToggleHidden?: () => void;
  isHidden?: boolean;
}

function ListActionButtons({
  onUpdate,
  onDelete,
  onToggleHidden,
  isHidden,
}: Props) {
  const canToggleHidden = !!onToggleHidden && typeof isHidden === 'boolean';

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end">
      {canToggleHidden && (
        <Tooltip title={isHidden ? 'show' : 'hide'}>
          <IconButton
            size="small"
            onClick={onToggleHidden}
            aria-label={isHidden ? 'show' : 'hide'}
          >
            {isHidden ? (
              <Visibility sx={{ fontSize: 18 }} />
            ) : (
              <VisibilityOff sx={{ fontSize: 18 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="edit">
        <IconButton size="small" onClick={onUpdate} aria-label="edit">
          <Edit sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="delete">
        <IconButton size="small" onClick={onDelete} aria-label="delete">
          <Delete sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}

export default ListActionButtons;
